import { GemecoValidateAddressHandlerType } from "@gemeco/Handlers/GemecoValidateAddress";
import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import {
    chain,
    ValidateShippingAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";

export type HandlerType = Parameters<typeof ValidateShippingAddress>[0];

replaceInChain(chain, ValidateShippingAddress, ModifiedValidateShippingAddress);

async function ModifiedValidateShippingAddress(props: HandlerType) {
    const state = props.getState();
    const {
        context: { session },
    } = state;
    if (session.fulfillmentMethod === FulfillmentMethod.PickUp) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const byPassAddressValidation =
        (props.parameter as unknown as GemecoValidateAddressHandlerType)?.byPassAddressValidation ?? false;
    const shippingAddressErrors = await awaitableValidate({
        address: props.shipTo,
        validationRules: props?.shipTo?.validation,
        addressFieldDisplayCollection: addressFieldsDataView.value!.shipToAddressFields,
        // BESUP-37 added additional parameter to address validate
        isOneTimeAddress: props?.shipTo?.oneTimeAddress,
        byPassAddressValidation,
    } as GemecoValidateAddressHandlerType)(props.dispatch, props.getState);
    // BESUP-37
    const isShippingAddressValid = Object.keys(shippingAddressErrors).length === 0;

    props.dispatch({
        type: "Pages/CheckoutShipping/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: !isShippingAddressValid,
    });
}